<template>

    <div>        
        <!--================Home Banner Area =================-->
        <Header />
        
        <Banner v-bind:content_section="getSection('icones_banner')"/>
        <!--================End Home Banner Area =================-->

        <!--================About Area =================-->
        <About v-bind:content_section="getSection('conheca_a_dlealp')"/>
        <!--================End About Area =================-->

        <!--================Furniture Area =================-->
        <RecentProjects v-bind:content_section="getSection('projetos_recentes')"/>
        <!--================End Furniture Area =================-->

        <!--================Projects Area =================-->
        <Categories v-bind:content_section="getSection('categorias')"/>
        <!--================End Projects Area =================-->

        <!--================Feature Area =================-->
        <Services v-bind:content_section="getSection('porque_somos_unicos')"/>
        <!--================End Feature Area =================-->

        <!--================Impress Area =================-->
        <Contact v-bind:content_section="getSection('esta_a_procura_de_algo_especifico')"/>
        <!--================End Impress Area =================-->

        <!--================Our Blog Area =================-->
        <Social v-bind:content_section="getSection('instagram')"/>
        <!--================End Our Blog Area =================-->

        <!--================Clients Logo Area =================-->
        <Clients v-bind:content_section="getSection('clientes')"/>
        <!--================End Clients Logo Area =================-->

        <!--================Footer Area =================-->
        <Footer v-bind:content_section="getSection('rodape')"/>
        <!--================End Footer Area =================-->
    </div>

</template>

<script>

    import axios from 'axios';
    import Vue from 'vue';
    import $ from "jquery";
    import SmoothScroll from 'smooth-scroll';

    import Header from '../components/header';
    import Banner from '../components/banner';
    import About from '../components/about';
    import RecentProjects from '../components/recent_projects';
    import Categories from '../components/categories';
    import Services from '../components/services';
    import Contact from '../components/contact';
    import Social from '../components/social';
    import Clients from '../components/clients';
    import Footer from '../components/footer';

    import {apiURL} from '../resources/apiUrl';

    let axiosInstance = axios.create();

    export default {

        name: 'home',

        components: {
            Header,
            Banner,
            About,
            RecentProjects,
            Categories,
            Services,
            Contact,
            Social,
            Clients,
            Footer
        },

        data() {
            return {
                sessionsPage: [],
            }
        },

        mounted() {
            let nav_offset_top = $('header').height() + 50;
            if ( $('.header_area').length ){ 
                $(window).scroll(function() {
                    var scroll = $(window).scrollTop();   
                    if (scroll >= nav_offset_top ) {
                        $(".header_area").addClass("navbar_fixed");
                    } else {
                        $(".header_area").removeClass("navbar_fixed");
                    }
                })
            }
            let scroll = new SmoothScroll('a[href*="#"]');
            $('.nav a').on('click', function(){
                $('.navbar-toggler').click();
            });
        },

        created() {

            axiosInstance.get(`${apiURL()}/lp`)
                .then(response => {
                    this.sessionsPage = response.data;
                })
                .catch(error => {
                    console.log(error);
                })

        },

        methods: {

           getSection(name){
               let section = {};
               this.sessionsPage.forEach( section_ => {
                   if (section_.name == name) {
                       section = section_
                   }
               });
               return section.content;
           }

        },

    }

</script>

<style>

</style>